function wrap(str, options) {
  options = options || {};
  if (str == null) {
    return str;
  }

  const width = options.width || 50;
  const indent = (typeof options.indent === 'string')
    ? options.indent
    : '';

  const newline = options.newline || `\n${indent}`;
  const escape = typeof options.escape === 'function'
    ? options.escape
    : identity;

  let regexString = `.{1,${width}}`;
  if (options.cut !== true) {
    regexString += '([\\s\u200B]+|$)|[^\\s\u200B]+?([\\s\u200B]+|$)';
  }

  const re = new RegExp(regexString, 'g');
  const lines = str.match(re) || [];
  let result = indent + lines.map((line) => {
    if (line.slice(-1) === '\n') {
      line = line.slice(0, line.length - 1);
    }
    return escape(line);
  }).join(newline);

  if (options.trim === true) {
    result = result.replace(/[ \t]*$/gm, '');
  }
  return result;
}

function identity(str) {
  return str;
}

/**
 *
 * @param {*} string string to be wrapped
 * @param {*} maxLength maxLength that each line can havee
 * @param {*} maxLines max number of lines allowed
 * @param {*} breakStrings can break strings? true = each string will be breaked to
 * fit the maxLength, false = it will not break the strings but it will split it by ' '
 */
export function wrapString(string, maxLength, maxLines, breakStrings) {
  const ellipsis = '...';

  // quebra a string em linhas de {maxLength} caracteres
  const wrapped = wrap(string, { width: maxLength, cut: breakStrings });
  // quebra a string em uma array de linhas
  const allowedLines = wrapped.split('\n')
    .slice(0, maxLines);

  function reduce(lines) {
    return lines.reduce((reduced, next) => `${reduced}\n${next}`);
  }

  // se o numero de quebras de linha inicial for menor
  // que o numero maximo de linhas, significa que a string
  // foi quebrada mas que não precisa adicionar ellipsis
  // pois o conteudo permanece intacto
  const breaks = (wrapped.match(/\n/g) || []).length;
  if (breaks < maxLines) {
    return reduce(allowedLines);
  }

  // processa a ultima linha para adicionar o ellipsis
  const linesWithEllipsis = allowedLines.map((line, index) => {
    if (allowedLines.length !== index + 1) {
      return line;
    }

    // calcula o length da ultima linha + o length do ellipsis
    const withEllipsisLength = line.length + ellipsis.length;
    // calcula o quanto da linha deverá ser cortada para que linha+ellipsis obedeça
    // o maxLength permitido
    const sizeThatWillBeDeleted = withEllipsisLength - maxLength;

    // se o tamanho do corte for <= 0, retorna linha + ellipsis
    if (sizeThatWillBeDeleted <= 0) {
      return `${line}${ellipsis}`;
    }

    // remove da linha o conteudo excedente e adiciona o ellipsis
    return line.slice(0, sizeThatWillBeDeleted * -1)
      .concat('...');
  });

  return reduce(linesWithEllipsis);
}
